import { registerPlugin } from '@capacitor/core';

import type { TestFlightDetectPlugin } from './definitions';

const TestFlightDetect = registerPlugin<TestFlightDetectPlugin>(
  'TestFlightDetect',
  {
    web: () => import('./web').then(m => new m.TestFlightDetectWeb()),
  },
);

export * from './definitions';
export { TestFlightDetect };
